import type { BookingDetailsData, TransferItem, TransfersData } from '../../domain/types'
import type { BookingDetailsServiceAPIResponse, TransferAPIResponse, TransfersAPIResponse } from '../types'

function mapTransferItem(item: TransferAPIResponse): TransferItem {
  return {
    pickupLocation: item.pickupLocation ?? '',
    pickupTime: item.pickupTime ?? '',
    isCancelled: item.status?.toLowerCase().startsWith('cancel') ?? false,
    pickupDate: item.pickupDate ?? '',
  }
}

export function transferDirectionsMapper(
  services?: BookingDetailsServiceAPIResponse[],
): { hasOutboundTransfer: boolean, hasInboundTransfer: boolean } {
  const transferServices = (services ?? []).filter(
    service =>
      service.type?.toLowerCase() === 'transfer'
      && (service.transferType?.toLowerCase() === 'normal'
        || service.transferType?.toLowerCase() === 'private'),
  )

  const hasOutboundTransfer = transferServices.some((s) => {
    const dir = s.direction?.toLowerCase()
    return dir === 'outbound' || dir === 'both'
  })

  const hasInboundTransfer = transferServices.some((s) => {
    const dir = s.direction?.toLowerCase()
    return dir === 'inbound' || dir === 'both'
  })

  return { hasOutboundTransfer, hasInboundTransfer }
}

export function transferTypeMapper(
  services?: BookingDetailsServiceAPIResponse[],
): BookingDetailsData['transferType'] {
  const transferServices = (services ?? []).filter(
    service => service.type?.toLowerCase() === 'transfer',
  )

  if (transferServices.length === 0) {
    return null
  }

  if (transferServices.some(s => s.transferType?.toLowerCase() === 'private')) {
    return 'Private'
  }

  if (transferServices.some(s => s.transferType?.toLowerCase() === 'normal')) {
    return 'Public'
  }

  return null
}

export function transfersMapper(apiResponse: TransfersAPIResponse): TransfersData {
  const transfers = apiResponse.transfers ?? []

  const outboundRaw = transfers.find(t => t.transferDirection?.toLowerCase() === 'a')
  const inboundRaw = transfers.find(t => t.transferDirection?.toLowerCase() === 'd')

  return {
    outbound: outboundRaw ? mapTransferItem(outboundRaw) : null,
    inbound: inboundRaw ? mapTransferItem(inboundRaw) : null,
  }
}
